var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDangerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 0.000335693C4.48649 0.000335693 0.000488281 4.48634 0.000488281 10.0003C0.000488281 15.5143 4.48649 20.0003 10.0005 20.0003C15.5145 20.0003 20.0005 15.5143 20.0005 10.0003C20.0005 4.48634 15.5145 0.000335693 10.0005 0.000335693ZM2.00049 10.0003C2.00049 8.15434 2.63449 6.45834 3.68849 5.10334L14.8975 16.3123C13.4995 17.4062 11.7755 18.0004 10.0005 18.0003C5.58949 18.0003 2.00049 14.4113 2.00049 10.0003ZM16.3125 14.8973L5.10349 3.68834C6.50154 2.59463 8.22546 2.00039 10.0005 2.00034C14.4115 2.00034 18.0005 5.58934 18.0005 10.0003C18 11.7753 17.4058 13.4991 16.3125 14.8973Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIcon);
export default __webpack_public_path__ + "static/media/danger-icon.665c56a9.svg";
export { ForwardRef as ReactComponent };